import React from 'react';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import withInit from 'WithInit';
import { AnimationConstants, AnimationActions } from 'Animation';
import ProgressBar from 'ProgressBar';
import ProgressBarStep from './ProgressBarStep';


export class ExportProgressBar extends React.Component {
  constructor(props) {
    super(props);

    const defaultCallback = () => {
      window.location.assign(props.href);
    };

    this.state = {
      progressBarStepAnimationTime: 3500,
      callbackToUse: props.callback || defaultCallback,
    };
  }

  componentDidMount() {
    const userId = window.COOKIE.get('userid');
    if (userId) {
      this.state.callbackToUse();
      return;
    }

    this.props.startProgressBarAnimation(4, this.state.progressBarStepAnimationTime);
  }

  componentDidUpdate() {
    const callbackToUse = this.state.callbackToUse;
    if (this.props.progressBarAnimation.finished) {
      setTimeout(() => {
        callbackToUse();
      }, 100);
    }
  }

  render() {
    const animationStarted = this.props.progressBarAnimation.started;
    return (
      <div className="export-progress-bar">
        <div className="export-progress-bar-content">
          <div className="progress-header">Preparing Document...</div>

          <ProgressBar
            progressBarClassName="progress-bar"
            progressClassName="progress-bar-progress"
            step={this.props.progressBarAnimation.step}
            totalSteps={this.props.progressBarAnimation.totalSteps}
          />

          <ul className="spinner-wrapper">
            <ProgressBarStep
              started={animationStarted && this.props.progressBarAnimation.step >= 0}
              completed={this.props.progressBarAnimation.step > 0}
              animationTime={this.state.progressBarStepAnimationTime}
              text="Proofreading clauses"
            />
            <ProgressBarStep
              started={animationStarted && this.props.progressBarAnimation.step >= 1}
              completed={this.props.progressBarAnimation.step > 1}
              animationTime={this.state.progressBarStepAnimationTime}
              text="Enabling electronic signatures"
            />
            <ProgressBarStep
              started={animationStarted && this.props.progressBarAnimation.step >= 2}
              completed={this.props.progressBarAnimation.step > 2}
              animationTime={this.state.progressBarStepAnimationTime}
              text="Preparing document in word and PDF formats"
            />
            <ProgressBarStep
              started={animationStarted && this.props.progressBarAnimation.step >= 3}
              completed={this.props.progressBarAnimation.finished}
              animationTime={this.state.progressBarStepAnimationTime}
              text="Eliminating spelling and grammar errors"
            />
          </ul>
        </div>
      </div>
    );
  }
}

ExportProgressBar.propTypes = {
  callback: PropTypes.func,
  href: PropTypes.string.isRequired,
  progressBarAnimation: PropTypes.shape({
    started: PropTypes.bool,
    finished: PropTypes.bool,
    step: PropTypes.number,
    totalSteps: PropTypes.number,
  }).isRequired,
  startProgressBarAnimation: PropTypes.func.isRequired,
};

ExportProgressBar.defaultProps = {
  callback: null,
};

const mapStateToProps = ({ AnimationReducer }) => (
  {
    progressBarAnimation: AnimationReducer[AnimationConstants.PROGRESS_BAR_ANIMATION],
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...AnimationActions,
  }, dispatch)
);


export const ExportProgressBarWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportProgressBar);

export default withInit(ExportProgressBarWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/ExportProgressBar/index.jsx